import i18n from '@/i18n';

export const popupData = (
  popupToggle: () => void,
  isUnblocking: boolean,
  unblock: () => Promise<void>,
  closePopup: () => Promise<void>
) => {
  return {
    blockedByYou: {
      title: i18n.t('pages.ad.you_blocked_user'),
      description: i18n.t('pages.ad.unblock_to_continue'),
      actions: {
        left: {
          isGray: true,
          text: i18n.t('common.deny'),
          onClick: popupToggle,
          disabled: isUnblocking,
        },
        right: {
          text: i18n.t('common.unblock'),
          onClick: unblock,
          disabled: isUnblocking,
        },
      },
    },
    blockedByOtherUser: {
      title: i18n.t('pages.ad.user_unavailable'),
      description: i18n.t('pages.ad.user_restricts_access'),
      actions: { left: { text: i18n.t('common.ok'), onClick: closePopup } },
    },
  };
};
